var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_vm._v(" "+_vm._s(_vm.$store.state.app.lang === 'zh-CN' ? '版权归 ©️ 把爱传下去 所有 All CopyRights Reserved' : 'CopyRIght ©️ Payitforward All CopyRights Reserved')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }